<template>
  <CCol class="ml-3 campaign-card">
    <div class="mt-3 p-3">
      <h3>
        {{ campaign.id_campaign }}
      </h3>
      <div v-if="isClosed">
        <h3 class="text-danger">{{ $t("Campaign") }} {{ $t("Closed") }}</h3>
        <h5>{{ $t("Closed on") }} {{ $tDate(sliceDate(campaign.date_end)) }}</h5>
      </div>
      <div v-else>
        <h3 class="text-info">{{ $t("Campaign") }} {{ $t("In Progress") }}</h3>
        <h5>{{ $t("Started on") }} {{ $tDate(sliceDate(campaign.date_start)) }}</h5>
      </div>
    </div>
    <div class="p-3" v-if="!isRoleUser">
      <table-component
        :show-number-of-lines="false"
        :columns="['Indicator', 'value']"
        :headings="tableHeadings"
        :filter-exclude-columns="['Indicator', 'value']"
        :sort-exclude-columns="['Indicator', 'value']"
        :display-columns-selector="false"
        :url="CAMPAIGNS_ENDPOINTS.kpi(campaign.id_campaign)"
      >
        <template slot="Indicator" slot-scope="{ row }">
          {{ $t(row.Indicator) }}
        </template>
        <template slot="value" slot-scope="{ row }">
          {{ $getNumericalValue(row.value, 0) }}
        </template>
      </table-component>
    </div>
    <CButton
      v-if="hasAccessAdmin"
      class="mz-button v2-mz-btn mr-2 float-left mb-3"
      color="primary"
      :to="{
        name: 'Campaign Details',
        params: { campaignId: campaign.id_campaign },
      }"
    >
      {{ $t("Admin") }}
    </CButton>
    <CButton
      v-if="hasAccessComplete && !isClosed"
      class="mz-button v2-mz-btn mr-2 float-right mb-3"
      color="primary"
      :to="{
        name: 'CampaignUpload',
        params: { campaignId: campaign.id_campaign },
      }"
    >
      {{ $t("Complete") }}
    </CButton>
  </CCol>
</template>

<script>
import {ActiveUser} from "@/services/user";
import {CAMPAIGNS_ENDPOINTS} from "@/services/campaigns";
import {userRoles} from "../../constants/userRoles";
import moment from "moment";

export default {
  name: "CampaignCard",
  data() {
    return {
      CAMPAIGNS_ENDPOINTS,
      isClosed: null,
    };
  },
  props: {
    campaign: Object,
  },
  async mounted() {
    this.isClosed = this.isCampaignClosed();
  },
  computed: {
    formattedDate() {
      return new Date().toJSON().slice(0, 10).replace(/-/g, "-");
    },
    tableHeadings() {
      return {
        Indicator: this.$t("Indicator"),
        value: '',
      };
    },
    hasAccessAdmin() {
      return ActiveUser.hasRole(userRoles.Admin) || ActiveUser.hasRole(userRoles.SuperUser)
    },
    hasAccessComplete() {
      return !ActiveUser.isSuperUser()
    },
    isRoleUser() {
      return ActiveUser.user.role === userRoles.User;
    }
  },
  methods: {
    sliceDate(date) {
      return moment(date.slice(0, 10), 'YYYY-MM-DD');
    },
    isCampaignClosed() {
      const currentTime = this.formattedDate;
      return this.campaign.date_end <= currentTime;
    },
  },
};
</script>

<style scoped lang="scss">
.campaign-card {
  background-color: $primary-100;
}

div.buttons-row {
  display: none !important;
  height: 0 !important;
}
</style>
